
export const isProd = () => window.location.host.indexOf('ismet.kz') >= 0;
export const isIsmetTest = () => window.location.host.indexOf('i-smet.kz') >= 0;
export const isTelecomProd = () => window.location.host.indexOf('telecom.kz') >= 0;
export const isLocalDev = () => window.location.host.indexOf('localhost') >= 0;

export const getApiBaseUrl = (foreignLink?: boolean): string => {
    if (isTelecomProd()) {
        return 'telecom.kz';
    }
    if (isProd()) {
        return 'ismet.kz';
    }
    if (isIsmetTest() || foreignLink) {
        return 'i-smet.kz';
    }
    return 'localhost:8080';
}

/** Тестовые стенды: *.i-smet.kz, test-*.telecom.kz, localhost. Всё остальное — прод (*.telecom.kz). */
export const isTestHost = (host: string = window.location.host): boolean =>
    host.includes('i-smet.kz') || host.includes('test-') || host.includes('localhost');

export const getB2bOrigin = (): string =>
    isTestHost() ? 'https://test-b2b.telecom.kz' : 'https://b2b.telecom.kz';

export const getIsmetIdUrl = (): string => {
    if (isTelecomProd()) {
        return 'https://b2b.telecom.kz/id';
    }
    return `https://test-b2b.telecom.kz/id`;
}
